import type { FC, ReactNode } from 'react';
import styles from './StatTile.module.css';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  delta?: string;
  trend?: 'up' | 'down' | 'flat';
  caption?: string;
}

export const StatTile: FC<StatTileProps> = ({
  label,
  value,
  delta,
  trend = 'flat',
  caption,
}) => (
  <div className={styles.tile}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
    <div className={styles.footer}>
      {delta && (
        <span className={styles.delta} data-trend={trend}>
          {delta}
        </span>
      )}
      {caption && <span className={styles.caption}>{caption}</span>}
    </div>
  </div>
);
